<template>
  <h2>🕰 {{duration}}</h2>
</template>

<script>
export default {
  name: "Chronometer",
  data() {
    return {
      elapsedTime: 0
    };
  },
  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        this.elapsedTime += 1000;
      }, 1000);
    }
  },
  computed: {
    duration() {
      const date = new Date(null);
      date.setSeconds(this.elapsedTime / 1000);
      const utc = date.toUTCString();
      return utc.substr(utc.indexOf(":") - 2, 8);
    }
  },
  created: function() {
    this.startTimer();
  }
};
</script>